var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-upload" },
    [
      _c(
        "el-form",
        [
          _c(
            "el-upload",
            {
              ref: "upload",
              style: { width: _vm.width, height: _vm.height },
              attrs: {
                disabled: _vm.isDisabled,
                limit: _vm.limitNumber,
                action: "",
                accept: "image/*",
                "http-request": _vm.uploadFile,
                "list-type": "picture-card",
                "auto-upload": true,
                "show-file-list": false,
                "on-preview": _vm.handlePictureCardPreview,
                "on-exceed": _vm.handleExceed,
                "before-remove": _vm.beforeRemove,
              },
            },
            [
              !_vm.imageUrl && !_vm.imageUrl2
                ? _c("div", { staticClass: "addbox" }, [
                    _c("img", {
                      staticClass: "addicon",
                      attrs: {
                        src: require("../../assets/icon_add_24hui@2x.png"),
                        alt: "",
                      },
                    }),
                  ])
                : _c(
                    "div",
                    {
                      staticStyle: {
                        position: "relative",
                        width: "106px",
                        height: "106px",
                      },
                    },
                    [
                      _c("img", {
                        staticStyle: { "object-fit": "contain" },
                        attrs: {
                          src: _vm.imageUrl || _vm.imageUrl2,
                          width: "100%",
                          height: "100%",
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticClass: "close",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleRemove()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-close",
                            staticStyle: {
                              color: "#2d46ee",
                              "font-size": "16px",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  width: "100%",
                  fit: "contain",
                  src: _vm.dialogImageUrl,
                  alt: "",
                },
              }),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }